module.exports = __webpack_public_path__ + "img/LicensesAndActivationsBtn.15d03515.png";